<template>
  <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
    <CModal
      :closeOnBackdrop="false"
      :show.sync="modal"
      :no-close-on-backdrop="false"
      :centered="true"
      title=""
      size="lg"
      color="dark"
    >
      <CCard>
        <CCardBody>
          <CAlert
            v-if="alertMsg"
            :color="alertClr"
            closeButton
            fade
          >
            {{ alertMsg }}
          </CAlert>
          <CForm>
            <CInput
              label="所属"
              v-model="userInfo.organization_name"
              horizontal
              readonly
            />
            <CInput
              label="社員番号"
              v-model="userInfo.user_id"
              horizontal
              readonly
            />
            <CInput
              label="氏名"
              v-model="userInfo.fullname"
              horizontal
              readonly
            />
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="スキル"
            >
              <div class="form-group form-row">
                <label class="col-form-label col-sm-3">スキル *</label>
                <div class="col-sm-9">
                  <v-select
                    label="skill_fullname"
                    placeholder="選択してください"
                    v-model="inputItems.skill_id"
                    :options="skills"
                    :reduce="(v) => v.skill_id"
                  >
                    <template #no-options> 選択肢が見つかりません。 </template>
                  </v-select>
                </div>
              </div>
              <div class="validation-error">
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              :rules="`max:${constdata.SKILLINFO_NOTE_MAX_LEN}`"
              v-slot="{ errors }"
              name="備考"
              vid="note"
            >
              <CTextarea
                class="labelsFont"
                rows="5"
                label="備考"
                v-model="inputItems.note"
              ></CTextarea>
              <div class="validation-error">
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </CForm>
        </CCardBody>
      </CCard>
      <template #header>
        <h6 class="modal-title">スキル情報登録</h6>
        <CButtonClose @click="closeModal" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="alertValidation(handleSubmit(register))" color="success">登録</CButton>
      </template>
    </CModal>
  </ValidationObserver>
</template>

<script>
import constMsg from "../../../definition/const/const_message.js";
import constdata from "../../../definition/const/const_userSkill.js";
export default {
  name: "SkillInfoAddModal",
  data() {
    return {
      inputItems: {
        user_id: null,
        skill_id: null,
        experience_term: 0,
        self_study_flag: true,
        note: null,
      },
      userInfo: {
        user_id: null,
        fullname: null,
        organization_name: null,
      },
      modal: false,
      alertMsg: "",
      alertClr: "",
      skills: [],
      constdata: constdata,
    };
  },
  watch: {
    visible: {
      handler: async function () {
        this.modal = this.visible;
        // 画面表示ONの時、最新データ取得
        if (this.modal) {
          await this.fetchData();
          // スキルリストから登録済みスキルの重複を除外
          this.skillListExclusion();
        }
      },
    },
  },
  props: {
    visible: {
      type: Boolean, // Boolean型に限定
      required: true, // 必須項目
    },
    index: {
      type: Number,
    },
    selectedSkills: {
      type: Array,
    }
  },
  async mounted() {
    // 初期データ取得
    await this.fetchData();
  },
  methods: {
    closeModal() {
      // 入力項目初期化
      Object.assign(this.$data.inputItems, this.$options.data().inputItems);
      // 初期化時に発生するバリデーションエラーをリセット
      this.$refs.observer.reset();
      // バリデーションエラーのメッセージを非表示
      this.alertMsg = "";
      // クローズ処理
      this.modal = false;
      this.$emit("close");
    },
    alertValidation() {
      // バリデーションエラーがあればエラーメッセージを表示
      this.$refs.observer.validate().then((success) => {
        if (!success) {
          // モーダルを閉じずにバリデーションエラーメッセージを表示
          this.alertClr = "danger";
          this.alertMsg =
            "入力内容に不備があります。詳細は各項目を確認してください。";
          // モーダルトップへスクロール
          this.$refs["modal-title"].scrollIntoView({
            behavior: "smooth",
            block: "end",
          });
        }
      });
    },
    async register() {
      var param = this.inputItems;
      // ログインユーザーIDをパラメーターに含める
      param.login_user_id = this.$store.state.loginUser.user_id;
      // 登録処理
      const ret = await this.createSkillInfo(param);
      // 入力項目初期化
      Object.assign(this.$data.inputItems, this.$options.data().inputItems);
      // 初期化時に発生するバリデーションエラーをリセット
      this.$refs.observer.reset();
      // バリデーションエラーのメッセージを非表示
      this.alertMsg = "";
      // クローズ処理
      this.modal = false;
      this.$emit("close", ret);
    },
    async createSkillInfo(param) {
      let ret = {};
      await this.$axios
        .post("/api/v1/userskills", param)
        .then((res) => {
          ret.alertClr = "success";
          ret.alertMsg = constMsg.I0002_JP;
        })
        .catch((e) => {
          ret.alertClr = "danger";
          ret.alertMsg = e.response.data.message;
        });
      return ret;
    },
    async fetchData() {
      // スキルリストデータセット
      this.skills = await this.getSkillList();
      // ログインユーザー情報セット
      var loginUser = await this.getUserInfo(
        this.$store.state.loginUser.user_id
      );
      this.inputItems.user_id = loginUser.user_id;
      this.userInfo.user_id = loginUser.user_id;
      this.userInfo.fullname = `${loginUser.lastname} ${loginUser.firstname}`;
      this.userInfo.organization_name =
        loginUser.m_organization.abbreviation;
    },
    async getSkillList() {
      let ret = null;
      await this.$axios
        .get("/api/v1/skills")
        .then((res) => {
          ret = res.data.skills;
          ret.map(function (x) {
            if (x.skill_version != null) {
              return (x.skill_fullname = `${x.skill_name} ${x.skill_version}`);
            } else {
              return (x.skill_fullname = x.skill_name);
            }
          });
        })
        .catch((e) => {
          console.error(e.response.data.message);
        });
      return ret;
    },
    async getUserInfo(id) {
      let ret = null;
      await this.$axios
        .get("/api/v1/users/" + id)
        .then((res) => {
          ret = res.data.users;
        })
        .catch((e) => {
          this.errorMsg = "Error! Could not reach the API. " + e;
          console.log(this.errorMsg);
        });
      return ret;
    },
    //
    async skillListExclusion(){
      for(var i = 0; i < this.selectedSkills.length; i++){
        for(var j = 0; j < this.skills.length; j++){
          // 合致するskillidをリストから除外
          if(this.skills[j].skill_id === this.selectedSkills[i]){
            this.skills.splice(j,1);
            break;
          }
        }
      }
    }
  },
};
</script>